import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { TextFormat, Translate } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity } from './identification-code-alert.reducer';

export const IdentificationCodeAlertDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const identificationCodeAlertEntity = useAppSelector(state => state.identificationCodeAlert.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="identificationCodeAlertDetailsHeading">
          <Translate contentKey="fleetSenseApp.identificationCodeAlert.detail.title">IdentificationCodeAlert</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{identificationCodeAlertEntity.id}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="fleetSenseApp.identificationCodeAlert.value">Value</Translate>
            </span>
          </dt>
          <dd>{identificationCodeAlertEntity.value}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="fleetSenseApp.identificationCodeAlert.created">Created</Translate>
            </span>
          </dt>
          <dd>
            {identificationCodeAlertEntity.created ? <TextFormat value={identificationCodeAlertEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <Translate contentKey="fleetSenseApp.identificationCodeAlert.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{identificationCodeAlertEntity.truckImplement ? identificationCodeAlertEntity.truckImplement.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.identificationCodeAlert.company">Company</Translate>
          </dt>
          <dd>{identificationCodeAlertEntity.company ? identificationCodeAlertEntity.company.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.identificationCodeAlert.vehiclePosition">Vehicle Position</Translate>
          </dt>
          <dd>{identificationCodeAlertEntity.vehiclePosition ? identificationCodeAlertEntity.vehiclePosition.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/identification-code-alert" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/identification-code-alert/${identificationCodeAlertEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IdentificationCodeAlertDetail;
